import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-glas-afval',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconGlasAfval {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M23.79 10.66c-1.92.01-3.76 1.13-4.57 3.01L18 16.49v18.44l2.45 1.06 7.94-18.35c.82-1.88.38-3.98-.93-5.39L32 1.77 28.33.18zM6 16v20h10v-8h-6v-9h6v-3c0-2.05-1.24-3.81-3-4.58V0H9v11.42c-1.76.77-3 2.53-3 4.58"/>
</svg>

    );
  }
}
